export default [
  {
      "asn": "15802",
      "carrier": "Du",
      "country": "AE"
  },
  {
      "asn": "5384",
      "carrier": "Etisalat",
      "country": "AE"
  },
  {
      "asn": "13335",
      "carrier": "Etisalat",
      "country": "AE"
  },
  {
      "asn": "19037",
      "carrier": "Claro",
      "country": "AR"
  },
  {
      "asn": "11315",
      "carrier": "Movistar",
      "country": "AR"
  },
  {
      "asn": "27871",
      "carrier": "Nextel",
      "country": "AR"
  },
  {
      "asn": "7303",
      "carrier": "Personal",
      "country": "AR"
  },
  {
      "asn": "16305",
      "carrier": "A1",
      "country": "AT"
  },
  {
      "asn": "1901",
      "carrier": "A1",
      "country": "AT"
  },
  {
      "asn": "8447",
      "carrier": "A1",
      "country": "AT"
  },
  {
      "asn": "12635",
      "carrier": "Drei",
      "country": "AT"
  },
  {
      "asn": "25255",
      "carrier": "Drei",
      "country": "AT"
  },
  {
      "asn": "8437",
      "carrier": "Tele2",
      "country": "AT"
  },
  {
      "asn": "8412",
      "carrier": "T-Mobile",
      "country": "AT"
  },
  {
      "asn": "55543",
      "carrier": "Lycamobile",
      "country": "AU"
  },
  {
      "asn": "4804",
      "carrier": "Optus",
      "country": "AU"
  },
  {
      "asn": "4778",
      "carrier": "Optus",
      "country": "AU"
  },
  {
      "asn": "1221",
      "carrier": "Telstra",
      "country": "AU"
  },
  {
      "asn": "45510",
      "carrier": "Telstra",
      "country": "AU"
  },
  {
      "asn": "7545",
      "carrier": "TPG",
      "country": "AU"
  },
  {
      "asn": "133612",
      "carrier": "Vodafone",
      "country": "AU"
  },
  {
      "asn": "56138",
      "carrier": "Airtel",
      "country": "BD"
  },
  {
      "asn": "38069",
      "carrier": "Airtel",
      "country": "BD"
  },
  {
      "asn": "45245",
      "carrier": "Banglalink",
      "country": "BD"
  },
  {
      "asn": "24389",
      "carrier": "Grameenphone",
      "country": "BD"
  },
  {
      "asn": "24432",
      "carrier": "Robi",
      "country": "BD"
  },
  {
      "asn": "45925",
      "carrier": "TeleTalk",
      "country": "BD"
  },
  {
      "asn": "44944",
      "carrier": "Base",
      "country": "BE"
  },
  {
      "asn": "47377",
      "carrier": "Orange",
      "country": "BE"
  },
  {
      "asn": "5432",
      "carrier": "Proximus",
      "country": "BE"
  },
  {
      "asn": "6848",
      "carrier": "Telenet",
      "country": "BE"
  },
  {
      "asn": "12716",
      "carrier": "A1",
      "country": "BG"
  },
  {
      "asn": "43205",
      "carrier": "Bulsatcom",
      "country": "BG"
  },
  {
      "asn": "42735",
      "carrier": "Max",
      "country": "BG"
  },
  {
      "asn": "29244",
      "carrier": "Telenor",
      "country": "BG"
  },
  {
      "asn": "2944",
      "carrier": "Telenor",
      "country": "BG"
  },
  {
      "asn": "8866",
      "carrier": "Vivacom",
      "country": "BG"
  },
  {
      "asn": "51375",
      "carrier": "VIVA",
      "country": "BH"
  },
  {
      "asn": "10101",
      "carrier": "DST",
      "country": "BN"
  },
  {
      "asn": "16735",
      "carrier": "Algar Telecom",
      "country": "BR"
  },
  {
      "asn": "53006",
      "carrier": "Algar Telecom",
      "country": "BR"
  },
  {
      "asn": "22085",
      "carrier": "Claro",
      "country": "BR"
  },
  {
      "asn": "4230",
      "carrier": "Claro",
      "country": "BR"
  },
  {
      "asn": "28573",
      "carrier": "Claro",
      "country": "BR"
  },
  {
      "asn": "53037",
      "carrier": "Nextel",
      "country": "BR"
  },
  {
      "asn": "8167",
      "carrier": "OI",
      "country": "BR"
  },
  {
      "asn": "7738",
      "carrier": "OI",
      "country": "BR"
  },
  {
      "asn": "22689",
      "carrier": "Sercomtel",
      "country": "BR"
  },
  {
      "asn": "26615",
      "carrier": "TIM",
      "country": "BR"
  },
  {
      "asn": "27699",
      "carrier": "Vivo",
      "country": "BR"
  },
  {
      "asn": "18881",
      "carrier": "Vivo",
      "country": "BR"
  },
  {
      "asn": "26599",
      "carrier": "Vivo",
      "country": "BR"
  },
  {
      "asn": "37447",
      "carrier": "Tigo",
      "country": "CD"
  },
  {
      "asn": "37453",
      "carrier": "Vodacom",
      "country": "CD"
  },
  {
      "asn": "15796",
      "carrier": "Salt",
      "country": "CH"
  },
  {
      "asn": "6730",
      "carrier": "Sunrise",
      "country": "CH"
  },
  {
      "asn": "203855",
      "carrier": "Sunrise",
      "country": "CH"
  },
  {
      "asn": "57370",
      "carrier": "Swisscom",
      "country": "CH"
  },
  {
      "asn": "3303",
      "carrier": "Swisscom",
      "country": "CH"
  },
  {
      "asn": "8300",
      "carrier": "Swisscom",
      "country": "CH"
  },
  {
      "asn": "36974",
      "carrier": "MTN",
      "country": "CI"
  },
  {
      "asn": "29571",
      "carrier": "Orange",
      "country": "CI"
  },
  {
      "asn": "27995",
      "carrier": "Claro",
      "country": "CL"
  },
  {
      "asn": "27925",
      "carrier": "Entel",
      "country": "CL"
  },
  {
      "asn": "6471",
      "carrier": "Entel",
      "country": "CL"
  },
  {
      "asn": "27651",
      "carrier": "Entel",
      "country": "CL"
  },
  {
      "asn": "7418",
      "carrier": "Movistar",
      "country": "CL"
  },
  {
      "asn": "22047",
      "carrier": "VTR",
      "country": "CL"
  },
  {
      "asn": "52341",
      "carrier": "WOM",
      "country": "CL"
  },
  {
      "asn": "30992",
      "carrier": "MTN",
      "country": "CM"
  },
  {
      "asn": "26611",
      "carrier": "Claro",
      "country": "CO"
  },
  {
      "asn": "14080",
      "carrier": "Claro",
      "country": "CO"
  },
  {
      "asn": "27831",
      "carrier": "Tigo",
      "country": "CO"
  },
  {
      "asn": "11830",
      "carrier": "ICE",
      "country": "CR"
  },
  {
      "asn": "262202",
      "carrier": "Movistar",
      "country": "CR"
  },
  {
      "asn": "15805",
      "carrier": "MTN",
      "country": "CY"
  },
  {
      "asn": "40964",
      "carrier": "Astelnet",
      "country": "CZ"
  },
  {
      "asn": "13036",
      "carrier": "T-Mobile",
      "country": "CZ"
  },
  {
      "asn": "16019",
      "carrier": "Vodafone",
      "country": "CZ"
  },
  {
      "asn": "702",
      "carrier": "O2",
      "country": "DE"
  },
  {
      "asn": "39706",
      "carrier": "O2",
      "country": "DE"
  },
  {
      "asn": "12638",
      "carrier": "O2",
      "country": "DE"
  },
  {
      "asn": "3320",
      "carrier": "Telekom",
      "country": "DE"
  },
  {
      "asn": "3209",
      "carrier": "Vodafone",
      "country": "DE"
  },
  {
      "asn": "6400",
      "carrier": "Claro",
      "country": "DO"
  },
  {
      "asn": "23487",
      "carrier": "Claro",
      "country": "EC"
  },
  {
      "asn": "14420",
      "carrier": "CNT",
      "country": "EC"
  },
  {
      "asn": "28006",
      "carrier": "CNT",
      "country": "EC"
  },
  {
      "asn": "19114",
      "carrier": "Movistar",
      "country": "EC"
  },
  {
      "asn": "36992",
      "carrier": "Etisalat",
      "country": "EG"
  },
  {
      "asn": "37069",
      "carrier": "Orange",
      "country": "EG"
  },
  {
      "asn": "30995",
      "carrier": "Vodafone",
      "country": "EG"
  },
  {
      "asn": "24835",
      "carrier": "Vodafone",
      "country": "EG"
  },
  {
      "asn": "36935",
      "carrier": "Vodafone",
      "country": "EG"
  },
  {
      "asn": "8239",
      "carrier": "BT",
      "country": "ES"
  },
  {
      "asn": "8903",
      "carrier": "BT",
      "country": "ES"
  },
  {
      "asn": "12541",
      "carrier": "BT",
      "country": "ES"
  },
  {
      "asn": "57269",
      "carrier": "DigiMobil",
      "country": "ES"
  },
  {
      "asn": "12338",
      "carrier": "Euskaltel",
      "country": "ES"
  },
  {
      "asn": "12715",
      "carrier": "Jazztel",
      "country": "ES"
  },
  {
      "asn": "3352",
      "carrier": "Movistar",
      "country": "ES"
  },
  {
      "asn": "12479",
      "carrier": "Orange",
      "country": "ES"
  },
  {
      "asn": "12386",
      "carrier": "Orange",
      "country": "ES"
  },
  {
      "asn": "16372",
      "carrier": "Orange",
      "country": "ES"
  },
  {
      "asn": "20921",
      "carrier": "Orange",
      "country": "ES"
  },
  {
      "asn": "12357",
      "carrier": "Vodafone",
      "country": "ES"
  },
  {
      "asn": "12430",
      "carrier": "Vodafone",
      "country": "ES"
  },
  {
      "asn": "16299",
      "carrier": "Yoigo",
      "country": "ES"
  },
  {
      "asn": "16086",
      "carrier": "DNA",
      "country": "FI"
  },
  {
      "asn": "719",
      "carrier": "Elisa",
      "country": "FI"
  },
  {
      "asn": "1759",
      "carrier": "Telia",
      "country": "FI"
  },
  {
      "asn": "21093",
      "carrier": "Bouygues",
      "country": "FR"
  },
  {
      "asn": "5410",
      "carrier": "Bouygues",
      "country": "FR"
  },
  {
      "asn": "51207",
      "carrier": "Free",
      "country": "FR"
  },
  {
      "asn": "3215",
      "carrier": "Orange",
      "country": "FR"
  },
  {
      "asn": "25186",
      "carrier": "Orange",
      "country": "FR"
  },
  {
      "asn": "28708",
      "carrier": "Orange",
      "country": "FR"
  },
  {
      "asn": "5511",
      "carrier": "Orange",
      "country": "FR"
  },
  {
      "asn": "15557",
      "carrier": "SFR",
      "country": "FR"
  },
  {
      "asn": "12576",
      "carrier": "EE",
      "country": "GB"
  },
  {
      "asn": "31404",
      "carrier": "Lycamobile",
      "country": "GB"
  },
  {
      "asn": "29180",
      "carrier": "O2",
      "country": "GB"
  },
  {
      "asn": "34825",
      "carrier": "O2",
      "country": "GB"
  },
  {
      "asn": "15169",
      "carrier": "O2",
      "country": "GB"
  },
  {
      "asn": "60339",
      "carrier": "Three",
      "country": "GB"
  },
  {
      "asn": "25135",
      "carrier": "Vodafone",
      "country": "GB"
  },
  {
      "asn": "37140",
      "carrier": "AirtelTigo",
      "country": "GH"
  },
  {
      "asn": "37255",
      "carrier": "MTN",
      "country": "GH"
  },
  {
      "asn": "29614",
      "carrier": "Vodafone",
      "country": "GH"
  },
  {
      "asn": "16022",
      "carrier": "Cosmoline",
      "country": "GR"
  },
  {
      "asn": "29247",
      "carrier": "Cosmote",
      "country": "GR"
  },
  {
      "asn": "12361",
      "carrier": "Vodafone",
      "country": "GR"
  },
  {
      "asn": "15617",
      "carrier": "Wind",
      "country": "GR"
  },
  {
      "asn": "25472",
      "carrier": "Wind",
      "country": "GR"
  },
  {
      "asn": "52362",
      "carrier": "Claro",
      "country": "GT"
  },
  {
      "asn": "12127",
      "carrier": "Movistar",
      "country": "GT"
  },
  {
      "asn": "23243",
      "carrier": "Tigo",
      "country": "GT"
  },
  {
      "asn": "14754",
      "carrier": "Claro",
      "country": "HN"
  },
  {
      "asn": "7727",
      "carrier": "HonduTel",
      "country": "HN"
  },
  {
      "asn": "52262",
      "carrier": "Tigo",
      "country": "HN"
  },
  {
      "asn": "5391",
      "carrier": "T-mobile",
      "country": "HR"
  },
  {
      "asn": "31012",
      "carrier": "Vip",
      "country": "HR"
  },
  {
      "asn": "27653",
      "carrier": "Digicel",
      "country": "HT"
  },
  {
      "asn": "52260",
      "carrier": "Natcom",
      "country": "HT"
  },
  {
      "asn": "5483",
      "carrier": "Magyar Telekom",
      "country": "HU"
  },
  {
      "asn": "8448",
      "carrier": "Telenor",
      "country": "HU"
  },
  {
      "asn": "21334",
      "carrier": "Vodafone",
      "country": "HU"
  },
  {
      "asn": "38494",
      "carrier": "Bakrie Telecom",
      "country": "ID"
  },
  {
      "asn": "38149",
      "carrier": "Bakrie Telecom",
      "country": "ID"
  },
  {
      "asn": "4761",
      "carrier": "Indosat Ooredoo",
      "country": "ID"
  },
  {
      "asn": "4832",
      "carrier": "Internux",
      "country": "ID"
  },
  {
      "asn": "133798",
      "carrier": "Smartfren",
      "country": "ID"
  },
  {
      "asn": "23693",
      "carrier": "Telkomsel",
      "country": "ID"
  },
  {
      "asn": "17974",
      "carrier": "Telkomsel",
      "country": "ID"
  },
  {
      "asn": "17885",
      "carrier": "XL",
      "country": "ID"
  },
  {
      "asn": "24203",
      "carrier": "XL",
      "country": "ID"
  },
  {
      "asn": "45727",
      "carrier": "XL",
      "country": "ID"
  },
  {
      "asn": "5466",
      "carrier": "eir Mobile",
      "country": "IE"
  },
  {
      "asn": "15751",
      "carrier": "Meteor",
      "country": "IE"
  },
  {
      "asn": "34218",
      "carrier": "Three",
      "country": "IE"
  },
  {
      "asn": "13280",
      "carrier": "Three",
      "country": "IE"
  },
  {
      "asn": "15502",
      "carrier": "Vodafone",
      "country": "IE"
  },
  {
      "asn": "55831",
      "carrier": "Aircel",
      "country": "IN"
  },
  {
      "asn": "45514",
      "carrier": "Airtel",
      "country": "IN"
  },
  {
      "asn": "24560",
      "carrier": "Airtel",
      "country": "IN"
  },
  {
      "asn": "45609",
      "carrier": "Airtel",
      "country": "IN"
  },
  {
      "asn": "9498",
      "carrier": "Airtel",
      "country": "IN"
  },
  {
      "asn": "9829",
      "carrier": "BSNL",
      "country": "IN"
  },
  {
      "asn": "45271",
      "carrier": "Idea",
      "country": "IN"
  },
  {
      "asn": "55644",
      "carrier": "Idea",
      "country": "IN"
  },
  {
      "asn": "18101",
      "carrier": "Reliance",
      "country": "IN"
  },
  {
      "asn": "55836",
      "carrier": "Reliance",
      "country": "IN"
  },
  {
      "asn": "4755",
      "carrier": "Tata",
      "country": "IN"
  },
  {
      "asn": "10199",
      "carrier": "Tata",
      "country": "IN"
  },
  {
      "asn": "45820",
      "carrier": "Tata",
      "country": "IN"
  },
  {
      "asn": "55441",
      "carrier": "Tata",
      "country": "IN"
  },
  {
      "asn": "3356",
      "carrier": "Telenor",
      "country": "IN"
  },
  {
      "asn": "23870",
      "carrier": "Telenor",
      "country": "IN"
  },
  {
      "asn": "21837",
      "carrier": "Vodafone",
      "country": "IN"
  },
  {
      "asn": "54994",
      "carrier": "Vodafone",
      "country": "IN"
  },
  {
      "asn": "1273",
      "carrier": "Vodafone",
      "country": "IN"
  },
  {
      "asn": "39832",
      "carrier": "Vodafone",
      "country": "IN"
  },
  {
      "asn": "17439",
      "carrier": "Vodafone",
      "country": "IN"
  },
  {
      "asn": "61317",
      "carrier": "Vodafone",
      "country": "IN"
  },
  {
      "asn": "38266",
      "carrier": "Vodafone",
      "country": "IN"
  },
  {
      "asn": "55410",
      "carrier": "Vodafone",
      "country": "IN"
  },
  {
      "asn": "1684",
      "carrier": "Asiacell",
      "country": "IQ"
  },
  {
      "asn": "51684",
      "carrier": "Asiacell",
      "country": "IQ"
  },
  {
      "asn": "59588",
      "carrier": "Zain",
      "country": "IQ"
  },
  {
      "asn": "44244",
      "carrier": "Irancell",
      "country": "IR"
  },
  {
      "asn": "197207",
      "carrier": "MCI",
      "country": "IR"
  },
  {
      "asn": "56746",
      "carrier": "MTCE",
      "country": "IR"
  },
  {
      "asn": "57218",
      "carrier": "Rightel",
      "country": "IR"
  },
  {
      "asn": "16232",
      "carrier": "TIM",
      "country": "IT"
  },
  {
      "asn": "24608",
      "carrier": "Tre",
      "country": "IT"
  },
  {
      "asn": "12663",
      "carrier": "Vodafone",
      "country": "IT"
  },
  {
      "asn": "30722",
      "carrier": "Vodafone",
      "country": "IT"
  },
  {
      "asn": "1267",
      "carrier": "Wind",
      "country": "IT"
  },
  {
      "asn": "33576",
      "carrier": "Digicel",
      "country": "JM"
  },
  {
      "asn": "48832",
      "carrier": "Zain",
      "country": "JO"
  },
  {
      "asn": "9605",
      "carrier": "NTT Docomo",
      "country": "JP"
  },
  {
      "asn": "36926",
      "carrier": "Airtel",
      "country": "KE"
  },
  {
      "asn": "12455",
      "carrier": "Orange",
      "country": "KE"
  },
  {
      "asn": "33771",
      "carrier": "Safaricom",
      "country": "KE"
  },
  {
      "asn": "9158",
      "carrier": "KT",
      "country": "KR"
  },
  {
      "asn": "17853",
      "carrier": "LG Uplus",
      "country": "KR"
  },
  {
      "asn": "3786",
      "carrier": "LG Uplus",
      "country": "KR"
  },
  {
      "asn": "9644",
      "carrier": "SK Telecom",
      "country": "KR"
  },
  {
      "asn": "38666",
      "carrier": "SK Telecom",
      "country": "KR"
  },
  {
      "asn": "29357",
      "carrier": "Ooredoo",
      "country": "KW"
  },
  {
      "asn": "47589",
      "carrier": "VIVA",
      "country": "KW"
  },
  {
      "asn": "42961",
      "carrier": "Zain",
      "country": "KW"
  },
  {
      "asn": "29357",
      "carrier": "Wataniya",
      "country": "KW"
  },
  {
      "asn": "29357",
      "carrier": "Wataniya",
      "country": "KW"
  },
  {
      "asn": "132045",
      "carrier": "Airtel",
      "country": "LK"
  },
  {
      "asn": "45517",
      "carrier": "Airtel",
      "country": "LK"
  },
  {
      "asn": "18001",
      "carrier": "Dialog",
      "country": "LK"
  },
  {
      "asn": "17770",
      "carrier": "Dialog",
      "country": "LK"
  },
  {
      "asn": "17470",
      "carrier": "Etisalat",
      "country": "LK"
  },
  {
      "asn": "132447",
      "carrier": "Hutch",
      "country": "LK"
  },
  {
      "asn": "45356",
      "carrier": "Mobitel",
      "country": "LK"
  },
  {
      "asn": "36884",
      "carrier": "Inwi",
      "country": "MA"
  },
  {
      "asn": "43494",
      "carrier": "Vip",
      "country": "MK"
  },
  {
      "asn": "12810",
      "carrier": "Vip",
      "country": "MK"
  },
  {
      "asn": "132167",
      "carrier": "Ooredoo",
      "country": "MM"
  },
  {
      "asn": "17072",
      "carrier": "Iusacell",
      "country": "MX"
  },
  {
      "asn": "7438",
      "carrier": "Movistar",
      "country": "MX"
  },
  {
      "asn": "28469",
      "carrier": "Nextel",
      "country": "MX"
  },
  {
      "asn": "28403",
      "carrier": "Telcel",
      "country": "MX"
  },
  {
      "asn": "10030",
      "carrier": "Celcom",
      "country": "MY"
  },
  {
      "asn": "4788",
      "carrier": "Celcom",
      "country": "MY"
  },
  {
      "asn": "4818",
      "carrier": "Digi",
      "country": "MY"
  },
  {
      "asn": "9534",
      "carrier": "Maxis",
      "country": "MY"
  },
  {
      "asn": "38466",
      "carrier": "U Mobile",
      "country": "MY"
  },
  {
      "asn": "45960",
      "carrier": "Yes",
      "country": "MY"
  },
  {
      "asn": "3269",
      "carrier": "Yes",
      "country": "MY"
  },
  {
      "asn": "21271",
      "carrier": "Norfolk Telecom",
      "country": "NF"
  },
  {
      "asn": "36873",
      "carrier": "Airtel",
      "country": "NG"
  },
  {
      "asn": "37076",
      "carrier": "Etisalat",
      "country": "NG"
  },
  {
      "asn": "37148",
      "carrier": "Glo",
      "country": "NG"
  },
  {
      "asn": "29465",
      "carrier": "MTN",
      "country": "NG"
  },
  {
      "asn": "31615",
      "carrier": "T-mobile",
      "country": "NL"
  },
  {
      "asn": "15480",
      "carrier": "Vodafone",
      "country": "NL"
  },
  {
      "asn": "33915",
      "carrier": "Vodafone",
      "country": "NL"
  },
  {
      "asn": "8529",
      "carrier": "Omantel",
      "country": "OM"
  },
  {
      "asn": "28885",
      "carrier": "Omantel",
      "country": "OM"
  },
  {
      "asn": "50010",
      "carrier": "Ooredoo",
      "country": "OM"
  },
  {
      "asn": "11556",
      "carrier": "Cable & Wireless PanamÃ¡",
      "country": "PA"
  },
  {
      "asn": "262227",
      "carrier": "Claro",
      "country": "PA"
  },
  {
      "asn": "28005",
      "carrier": "Digicel",
      "country": "PA"
  },
  {
      "asn": "262210",
      "carrier": "Bitel",
      "country": "PE"
  },
  {
      "asn": "12252",
      "carrier": "Claro",
      "country": "PE"
  },
  {
      "asn": "27702",
      "carrier": "Claro",
      "country": "PE"
  },
  {
      "asn": "21575",
      "carrier": "Entel",
      "country": "PE"
  },
  {
      "asn": "264684",
      "carrier": "Movistar",
      "country": "PE"
  },
  {
      "asn": "6147",
      "carrier": "Movistar",
      "country": "PE"
  },
  {
      "asn": "4775",
      "carrier": "Globe",
      "country": "PH"
  },
  {
      "asn": "132199",
      "carrier": "Globe",
      "country": "PH"
  },
  {
      "asn": "38196",
      "carrier": "Jazz",
      "country": "PK"
  },
  {
      "asn": "45669",
      "carrier": "Jazz",
      "country": "PK"
  },
  {
      "asn": "45127",
      "carrier": "Jazz",
      "country": "PK"
  },
  {
      "asn": "24499",
      "carrier": "Telenor",
      "country": "PK"
  },
  {
      "asn": "17557",
      "carrier": "Ufone",
      "country": "PK"
  },
  {
      "asn": "56167",
      "carrier": "Ufone",
      "country": "PK"
  },
  {
      "asn": "59257",
      "carrier": "Zong",
      "country": "PK"
  },
  {
      "asn": "5607",
      "carrier": "Cyfrowy Polsat",
      "country": "PL"
  },
  {
      "asn": "5617",
      "carrier": "Orange",
      "country": "PL"
  },
  {
      "asn": "39603",
      "carrier": "Play",
      "country": "PL"
  },
  {
      "asn": "8374",
      "carrier": "Plus",
      "country": "PL"
  },
  {
      "asn": "21243",
      "carrier": "Plus",
      "country": "PL"
  },
  {
      "asn": "12912",
      "carrier": "T-Mobile",
      "country": "PL"
  },
  {
      "asn": "12975",
      "carrier": "Jawwal",
      "country": "PS"
  },
  {
      "asn": "42863",
      "carrier": "MEO",
      "country": "PT"
  },
  {
      "asn": "2860",
      "carrier": "NOS",
      "country": "PT"
  },
  {
      "asn": "12353",
      "carrier": "Vodafone",
      "country": "PT"
  },
  {
      "asn": "11664",
      "carrier": "Claro",
      "country": "PY"
  },
  {
      "asn": "27895",
      "carrier": "Personal",
      "country": "PY"
  },
  {
      "asn": "23201",
      "carrier": "Tigo",
      "country": "PY"
  },
  {
      "asn": "42298",
      "carrier": "Ooredoo",
      "country": "QA"
  },
  {
      "asn": "8781",
      "carrier": "Ooredoo",
      "country": "QA"
  },
  {
      "asn": "48728",
      "carrier": "Vodafone",
      "country": "QA"
  },
  {
      "asn": "8400",
      "carrier": "MTS/Telekom Srbija",
      "country": "RS"
  },
  {
      "asn": "15958",
      "carrier": "Telenor",
      "country": "RS"
  },
  {
      "asn": "44143",
      "carrier": "Vip",
      "country": "RS"
  },
  {
      "asn": "8402",
      "carrier": "Beeline",
      "country": "RU"
  },
  {
      "asn": "34644",
      "carrier": "Beeline",
      "country": "RU"
  },
  {
      "asn": "16345",
      "carrier": "Beeline",
      "country": "RU"
  },
  {
      "asn": "25159",
      "carrier": "MegaFon",
      "country": "RU"
  },
  {
      "asn": "31208",
      "carrier": "MegaFon",
      "country": "RU"
  },
  {
      "asn": "31163",
      "carrier": "MegaFon",
      "country": "RU"
  },
  {
      "asn": "47395",
      "carrier": "MegaFon",
      "country": "RU"
  },
  {
      "asn": "31224",
      "carrier": "MegaFon",
      "country": "RU"
  },
  {
      "asn": "31205",
      "carrier": "MegaFon",
      "country": "RU"
  },
  {
      "asn": "31133",
      "carrier": "MegaFon",
      "country": "RU"
  },
  {
      "asn": "51737",
      "carrier": "MegaFon",
      "country": "RU"
  },
  {
      "asn": "31213",
      "carrier": "MegaFon",
      "country": "RU"
  },
  {
      "asn": "31195",
      "carrier": "MegaFon",
      "country": "RU"
  },
  {
      "asn": "8586",
      "carrier": "MegaFon",
      "country": "RU"
  },
  {
      "asn": "29209",
      "carrier": "MTS",
      "country": "RU"
  },
  {
      "asn": "28884",
      "carrier": "MTS",
      "country": "RU"
  },
  {
      "asn": "35473",
      "carrier": "MTS",
      "country": "RU"
  },
  {
      "asn": "25513",
      "carrier": "MTS",
      "country": "RU"
  },
  {
      "asn": "29497",
      "carrier": "MTS",
      "country": "RU"
  },
  {
      "asn": "8359",
      "carrier": "MTS",
      "country": "RU"
  },
  {
      "asn": "39811",
      "carrier": "MTS",
      "country": "RU"
  },
  {
      "asn": "13174",
      "carrier": "MTS",
      "country": "RU"
  },
  {
      "asn": "16256",
      "carrier": "MTS",
      "country": "RU"
  },
  {
      "asn": "21103",
      "carrier": "MTS",
      "country": "RU"
  },
  {
      "asn": "42437",
      "carrier": "Tele2",
      "country": "RU"
  },
  {
      "asn": "48190",
      "carrier": "Tele2",
      "country": "RU"
  },
  {
      "asn": "48092",
      "carrier": "Tele2",
      "country": "RU"
  },
  {
      "asn": "15378",
      "carrier": "Tele2",
      "country": "RU"
  },
  {
      "asn": "41330",
      "carrier": "Tele2",
      "country": "RU"
  },
  {
      "asn": "12958",
      "carrier": "Tele2",
      "country": "RU"
  },
  {
      "asn": "43766",
      "carrier": "Zain",
      "country": "SA"
  },
  {
      "asn": "36998",
      "carrier": "Zain",
      "country": "SD"
  },
  {
      "asn": "1257",
      "carrier": "Tele2",
      "country": "SE"
  },
  {
      "asn": "25169",
      "carrier": "Telenor",
      "country": "SE"
  },
  {
      "asn": "3301",
      "carrier": "Telia",
      "country": "SE"
  },
  {
      "asn": "44034",
      "carrier": "Tre",
      "country": "SE"
  },
  {
      "asn": "4773",
      "carrier": "M1",
      "country": "SG"
  },
  {
      "asn": "17547",
      "carrier": "M1",
      "country": "SG"
  },
  {
      "asn": "45143",
      "carrier": "SingTel",
      "country": "SG"
  },
  {
      "asn": "9874",
      "carrier": "StarHub",
      "country": "SG"
  },
  {
      "asn": "5610",
      "carrier": "O2",
      "country": "SK"
  },
  {
      "asn": "15962",
      "carrier": "Orange",
      "country": "SK"
  },
  {
      "asn": "6855",
      "carrier": "Slovak Telekom",
      "country": "SK"
  },
  {
      "asn": "16160",
      "carrier": "Viphone",
      "country": "SK"
  },
  {
      "asn": "27903",
      "carrier": "Digicel",
      "country": "SV"
  },
  {
      "asn": "27773",
      "carrier": "Tigo",
      "country": "SV"
  },
  {
      "asn": "133848",
      "carrier": "AIS",
      "country": "TH"
  },
  {
      "asn": "131445",
      "carrier": "AIS",
      "country": "TH"
  },
  {
      "asn": "132032",
      "carrier": "DTAC",
      "country": "TH"
  },
  {
      "asn": "24378",
      "carrier": "DTAC",
      "country": "TH"
  },
  {
      "asn": "133543",
      "carrier": "DTAC",
      "country": "TH"
  },
  {
      "asn": "24491",
      "carrier": "MY",
      "country": "TH"
  },
  {
      "asn": "131293",
      "carrier": "TOT",
      "country": "TH"
  },
  {
      "asn": "9737",
      "carrier": "TOT",
      "country": "TH"
  },
  {
      "asn": "23969",
      "carrier": "TOT",
      "country": "TH"
  },
  {
      "asn": "17552",
      "carrier": "True Move H",
      "country": "TH"
  },
  {
      "asn": "7470",
      "carrier": "True Move H",
      "country": "TH"
  },
  {
      "asn": "9287",
      "carrier": "True Move H",
      "country": "TH"
  },
  {
      "asn": "37693",
      "carrier": "Ooredoo",
      "country": "TN"
  },
  {
      "asn": "37492",
      "carrier": "Orange",
      "country": "TN"
  },
  {
      "asn": "2609",
      "carrier": "Tunisie Telecom",
      "country": "TN"
  },
  {
      "asn": "9121",
      "carrier": "Turk Telekom",
      "country": "TR"
  },
  {
      "asn": "20978",
      "carrier": "Turk Telekom",
      "country": "TR"
  },
  {
      "asn": "6755",
      "carrier": "Turk Telekom",
      "country": "TR"
  },
  {
      "asn": "47883",
      "carrier": "Turkcell",
      "country": "TR"
  },
  {
      "asn": "16135",
      "carrier": "Turkcell",
      "country": "TR"
  },
  {
      "asn": "15897",
      "carrier": "Vodafone",
      "country": "TR"
  },
  {
      "asn": "62211",
      "carrier": "Vodafone",
      "country": "TR"
  },
  {
      "asn": "31654",
      "carrier": "Vodafone",
      "country": "TR"
  },
  {
      "asn": "8386",
      "carrier": "Vodafone",
      "country": "TR"
  },
  {
      "asn": "15924",
      "carrier": "Vodafone",
      "country": "TR"
  },
  {
      "asn": "37075",
      "carrier": "Airtel",
      "country": "UG"
  },
  {
      "asn": "20294",
      "carrier": "MTN",
      "country": "UG"
  },
  {
      "asn": "10507",
      "carrier": "Sprint",
      "country": "US"
  },
  {
      "asn": "21928",
      "carrier": "T-Mobile",
      "country": "US"
  },
  {
      "asn": "7018",
      "carrier": "AT&T Services",
      "country": "US"
  },
  {
      "asn": "20057",
      "carrier": "AT&T Services",
      "country": "US"
  },
  {
      "asn": "22394",
      "carrier": "Cellco",
      "country": "US"
  },
  {
      "asn": "7922",
      "carrier": "Comcast",
      "country": "US"
  },
  {
      "asn": "11427",
      "carrier": "Time Warner",
      "country": "US"
  },
  {
      "asn": "209",
      "carrier": "Qwest",
      "country": "US"
  },
  {
      "asn": "19422",
      "carrier": "Movistar",
      "country": "UY"
  },
  {
      "asn": "45899",
      "carrier": "MobiFone",
      "country": "VN"
  },
  {
      "asn": "6739",
      "carrier": "MobiFone",
      "country": "VN"
  },
  {
      "asn": "131429",
      "carrier": "MobiFone",
      "country": "VN"
  },
  {
      "asn": "45903",
      "carrier": "MobiFone",
      "country": "VN"
  },
  {
      "asn": "37168",
      "carrier": "Cell C",
      "country": "ZA"
  },
  {
      "asn": "2905",
      "carrier": "MTN",
      "country": "ZA"
  },
  {
      "asn": "37457",
      "carrier": "MTN",
      "country": "ZA"
  },
  {
      "asn": "29975",
      "carrier": "Vodacom",
      "country": "ZA"
  },
  {
      "asn": "36994",
      "carrier": "Vodacom",
      "country": "ZA"
  }
]